var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnableProcess = function SvgUnableProcess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#unable-process_svg__a)",
    d: "M36 57.6c14.912 0 27-12.088 27-27s-12.088-27-27-27-27 12.088-27 27 12.088 27 27 27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36 50.4c10.935 0 19.8-8.864 19.8-19.8S46.935 10.8 36 10.8s-19.8 8.865-19.8 19.8S25.065 50.4 36 50.4",
    opacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DE6D2E",
    d: "M36 41.4a2.7 2.7 0 1 1 0-5.4 2.7 2.7 0 0 1 0 5.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#unable-process_svg__b)",
    d: "M36 33.3a2.7 2.7 0 0 1-2.7-2.7V22.5A2.7 2.7 0 0 1 36 19.8c1.491 0 2.7 1.207 2.7 2.699V30.6a2.7 2.7 0 0 1-2.7 2.7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#unable-process_svg__c)",
    d: "M35.813 66.6C23.99 66.6 14.4 65.774 14.4 64.75s9.59-1.851 21.414-1.851 21.414.826 21.414 1.85c0 1.026-9.59 1.852-21.414 1.852",
    opacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "unable-process_svg__a",
    x1: 43.558,
    x2: 43.558,
    y1: 80.572,
    y2: -15.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7D7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "unable-process_svg__b",
    x1: 36,
    x2: 36,
    y1: 19.8,
    y2: 33.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D83D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47B77"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "unable-process_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-21.1404 0 0 -1.99778 37.332 64.431)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042",
    stopOpacity: 0
  })))));
};
export default SvgUnableProcess;